<template>
  <div>
    <v-row
      class="px-3 d-flex align-center"
      v-for="(item, index) in result"
      :key="index"
      data-testid="resultList"
      @click="$emit('gotoLocation', { lat: item.lat, lon: item.lon })"
      style="position:relative;"
    >
      <v-col cols="2">
        <v-img
          :src="require('@/assets/icon/' + item.logo)"
          width="44"
          height="44"
        ></v-img>
      </v-col>
      <v-col cols="7" class="d-flex flex-column">
        <b style="color: #6A1B9A;font-size: small" data-testid="resultName">{{
          item.name
        }}</b>
        <span
          style="font-size: x-small;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
          data-testid="resultAddress"
        >
          {{ item.address }}
        </span>
        <span
          v-if="item.tel"
          style="width:fit-content;font-size: x-small;z-index: 0"
          data-testid="resultTel"
          @click="openTel(item.tel)"
          ><a>เบอร์โทรศัพท์: {{ item.tel }}</a>
        </span>
      </v-col>
      <v-col cols="3" class="d-flex justify-end">
        <v-btn
          small
          outlined
          color="#6A1B9A"
          width="68"
          height="52"
          @click="navigate(item)"
          data-testid="navigateBtn"
        >
          <div class="py-0 d-flex justify-center align-center flex-column">
            <div>
              <b
                ><span class="red--text"
                  ><span style="font-size: large;">{{ Number(item.km).toFixed(0) }}</span>
                  <span style="font-size: medium"> กม.</span>
                </span></b
              >
            </div>
            <div class="d-flex align-end">
              <v-icon small>mdi-near-me</v-icon
              ><span class="black--text" style="font-size:small"
                ><b>นำทาง</b></span
              >
            </div>
          </div>
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="navigatedialog">
      <v-card class="pa-1">
        <v-card-title>
          <v-row data-testid="navigateDialogTitle">
            <v-col cols="10" class="d-flex justify-center">
              <span class="purple--text" style="font-size: medium"
                ><b>เลือก Appplication นำทาง</b></span
              >
            </v-col>
            <v-col
              cols="2"
              @click="navigatedialog = false"
              style="cursor: pointer"
              data-testid="navigateDialogCloseBtn"
            >
              <v-icon class="red--text">mdi-close</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              v-for="(item, index) in navigateItems"
              :key="index"
              cols="4"
              class="d-flex flex-column justify-center align-center"
              @click="openMap(item)"
            >
              <v-img
                :src="require('@/assets/' + item.logo)"
                width="100%"
              ></v-img>
              <span class="pt-1 text-center">{{ item.text }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'result',
  mounted () {},
  computed: {},
  props: {
    result: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    navigate (item) {
      this.selectedLocation.name = item.name
      this.selectedLocation.lat = item.lat
      this.selectedLocation.lon = item.lon
      this.navigatedialog = true
    },
    openMap (item) {
      switch (item.text) {
        case 'Longdo':
          window.open(
            `https://map.longdo.com/mobile/go?tlat=${this.selectedLocation.lat}&tlon=${this.selectedLocation.lon}`
          )
          break
        case 'Google':
          window.open(
            `https://maps.google.com/?q=${this.selectedLocation.lat},${this.selectedLocation.lon}`
          )
          break
        case 'Apple':
          window.open(
            `https://maps.apple.com/?ll=${this.selectedLocation.lat},${this.selectedLocation.lon}&q=${this.selectedLocation.name}`
          )
          break
      }
    },
    openTel (tel) {
      window.open(`tel:${tel}`, '_self')
    }
  },
  data: () => ({
    navigatedialog: false,
    selectedLocation: {
      name: '',
      lat: 0,
      lon: 0
    },
    navigateItems: [
      {
        logo: 'longdomap.jpg',
        text: 'Longdo'
      },
      {
        logo: 'googlemap.png',
        text: 'Google'
      },
      {
        logo: 'applemap.png',
        text: 'Apple'
      }
    ]
  })
}
</script>

<style></style>
